module.exports = __webpack_public_path__ + "static/Forager8-3769d17f09f954ba3fddcdbb3db52b54.webp";